import ClipLoader from 'react-spinners/ClipLoader';
import React from 'react';

interface LoadingIconProps {
    color?: string;
    loading?: boolean;
    styles?: React.CSSProperties;
    size?: number;
    speed?: number;
}

export default function LoadingIcon(props: LoadingIconProps): JSX.Element {
    const {
        color = props.color || 'white',
        loading = props.loading || false,
        size = props.size || 10,
        speed = props.speed || 1,
        styles = props.styles,
    } = props;
    return <ClipLoader color={color} loading={loading} size={size} speedMultiplier={speed} cssOverride={styles} />;
}
